import { style } from '@angular/animations';
import { Component, OnInit, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { CupraModelModel } from '../../../models/cupramodel';
import { CupraModelService } from '../../../services/cupramodel.service';
import { environment } from 'src/environments/environment';
import { NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { CupraModelVersionService } from '../../../services/cupramodelversion.service';
import { CupraModelVersionModel } from '../../../models/cupramodelversion';
import { MotorTypeVersionModel } from '../../../models/motortype-version';
import { SeatFileFidelizationProductsCupraModel } from 'src/app/models/SeatFileFidelizationProductsCupra';
import { CupraBudgetModel } from 'src/app/models/cuprabudget';
import { BudgetBuilderService } from 'src/app/services/budgetbuilder.service';
import { Router } from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { Status } from 'src/app/models/enums';
import { CupraBudgetService } from 'src/app/services/budget.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './home.component.html',
  selector: 'ngbd-modal-basic',
  styleUrls: ['./home.component.scss']
})


export class HomeComponent implements OnInit {

  matricula: string;
  bastidor: string;
  idVersion: string;
  pathServer = environment.urlServer;

  cupramodels: CupraModelModel[] = [];
  cupramodelversions: CupraModelVersionModel[] = [];
  motortypes: any[] = [];
  motortypeversions: MotorTypeVersionModel[] = [];
  showValidationMotorVersionError: boolean = false;
  selectedModel: CupraModelModel;
  selectedVersion: CupraModelVersionModel;
  newBudget: CupraBudgetModel;
  oldBudget: string;
  showValidationBudgetError: boolean = false;
  closeResult = '';
  showNavigationIndicators = false;
  searchModel: SeatFileFidelizationProductsCupraModel;
  showCustomAlert = false;

  alertContent = {
    title: '',
    text: '',
    container: ''
  }


  activeIds: string[] = [];

  constructor(private cupraModelService: CupraModelService,
    private cupraModelVersionService: CupraModelVersionService,
    private cupraBudgetService: CupraBudgetService,
    private budgetBuilderService: BudgetBuilderService,
    private router: Router,
    private sharedService: SharedService,
    private modalService: NgbModal) { }


  ngOnInit() {
    this.loadMotorTypes();
    this.getModels();
  }

  loadMotorTypes() {
    this.sharedService.GetCupraModelVersionMotorType().subscribe(resp => {
      this.motortypes = resp;
    })
  }

  getModels() {
    this.cupraModelService.getAllActive().subscribe(resp => {
      this.cupramodels = resp;
      this.selectedModel = this.cupramodels[0];
      this.getModelVersions();
    }, (err) => {
      this.showAlert({
        title: '',
        text: 'Error al recuperar los datos',
        container: 'carrusel'
      });
    });
  }

  onSlid(slideEvent: NgbSlideEvent) {
    let idx = slideEvent.current.split("-")[1];
    this.selectedModel = this.cupramodels[idx];
    this.getModelVersions();
  }

  onSlide(slideEvent: NgbSlideEvent) {
    this.activeIds = [];
    this.motortypeversions = [];
    this.selectedVersion = null;
    this.selectedModel = null;
    this.setCarouselPosition();

  }

  getModelVersions() {
    const that = this;
    this.cupraModelVersionService.getAllActive(this.selectedModel.IdModel).subscribe(resp => {
      this.cupramodelversions = resp;
      this.cupramodelversions.forEach(function (version) {
        if (that.motortypeversions.some(x => x.IdMotorType == version.IdMotorType)) {
          let motortypeversion: MotorTypeVersionModel = that.motortypeversions.find(x => x.IdMotorType == version.IdMotorType);
          motortypeversion.ModelVersions.push(version);
        } else {
          let motortype = that.motortypes.find(x => x.id == version.IdMotorType);
          let newMotortypeversion: MotorTypeVersionModel = {
            IdMotorType: motortype.id,
            MotorType: motortype.text,
            ModelVersions: [version]
          };
          that.motortypeversions.push(newMotortypeversion);
        }
      });
    }, (err) => {
      this.showAlert({
        title: '',
        text: 'Error al recuperar los datos',
        container: 'carrusel'
      });
    });
  }

  SelectModelo() {
    if (this.selectedVersion != null) {
      this.postBudget(this.selectedVersion.IdModel, this.selectedVersion.IdVersion);
    } else {
      this.showValidationMotorVersionError = true;
    }

  }

  SelectMatricula() {

    this.budgetBuilderService.SearchbyMatricula("E" + this.matricula).subscribe(res => {
      if (res.IdData != null) {

        this.postBudget(res.IdModel, res.IdVersion, res);

      } else {
        this.showAlert({
          title: '',
          text: 'No se ha encontrado ningún vehículo con esta matrícula',
          container: 'search__plate'
        });

      }
    });
  }

  SelectBastidor() {

    this.budgetBuilderService.SearchbyBastidor(this.bastidor).subscribe(res => {

      if (res.IdData != null) {

        this.postBudget(res.IdModel, res.IdVersion, res);

      } else {
        this.showAlert({
          title: '',
          text: 'No se ha encontrado ningún vehículo con este número de bastidor',
          container: 'search__vin'
        });

      }
    });
  }

  SelectVersion(version: CupraModelVersionModel) {
    this.selectedVersion = version;
  }

  postBudget(idModel, idVersion, data: SeatFileFidelizationProductsCupraModel = null) {

    this.newBudget = new CupraBudgetModel();
    this.newBudget.IdVersion = idVersion;
    this.newBudget.IdModel = idModel;
    this.newBudget.IdStatus = Status.Pendiente;
    this.newBudget.IdBudget = "";
    this.newBudget.Email = "";
    this.newBudget.CcEmrSubscribed = false;

    if (data != null) {

      this.newBudget.Months = data.Months;
      this.newBudget.Matricula = data.Matricula ?? null;
      this.newBudget.Bastidor = data.Bastidor ?? null;
      this.newBudget.Km = data.Km;
      this.newBudget.IdDistributor = data.idDistributorCalc;
      this.newBudget.Distributor = data.Distributor;
      this.newBudget.DistributorCity = data.DistributorCity;
      this.newBudget.DistributorAddress = data.DistributorAddress;
      this.newBudget.DistributorCp = data.DistributorCp;
      this.newBudget.DistributorPhone = data.DistributorPhone;
      this.newBudget.IdProvince = data.IdProvince;
      this.newBudget.Workforce = data.Workforce;
      this.newBudget.CcEmrSubscribed = data.Maintenance;
      this.newBudget.HasMaintenance = data.Maintenance;
      this.newBudget.DiscountA = data.DiscountA;
      this.newBudget.DiscountB = data.DiscountB;
      this.newBudget.DiscountC = data.DiscountC;
    }

    this.cupraBudgetService.post(this.newBudget).subscribe(res => {
      this.router.navigate(['/specifications/' + res.IdBudget]);

    });

  }

  goToOldBudget() {

    if (this.oldBudget != null && this.oldBudget !== undefined && this.oldBudget != "") {

      this.cupraBudgetService.getByCode(this.oldBudget).subscribe(res => {

        if (res != null) {

          this.router.navigate(['/budget-preview/' + res.IdBudget]);

        } else {
          this.showAlert({
            title: '',
            text: 'No se ha encontrado ningún presupuesto con este código',
            container: 'oldBudgetSearchForm'
          });
        }

      }, (err) => {
        this.showAlert({
          title: '',
          text: 'Error al recuperar los datos',
          container: 'oldBudgetSearchForm'
        });

      });

    } else {
      this.showValidationBudgetError = true;
    }

  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true });
  }

  setCarouselPosition() {
    let carContainer = document.querySelector(".cupra-model-container");
    let slideControls = document.querySelectorAll<HTMLSpanElement>("button[class^='carousel-control']");

    if (carContainer.clientHeight > 0) {
      let newControlHeight = String(carContainer.clientHeight * 0.85 + 'px');
      let newControlPadding = String(carContainer.clientHeight / 2 + 'px');
      slideControls.forEach(slideControl => {
        slideControl.style.height = newControlHeight;
        slideControl.style.paddingTop = newControlPadding;
      });
    }

  }

  showAlert(attrs) {
    this.alertContent = attrs;
    const container = document.getElementById('calculatorBody');
    const alertContainer = document.getElementById('customAlertContainer');
    container.append(alertContainer);
    setTimeout(() => {
      this.showCustomAlert = true;
    }, 300);
    setTimeout(() => {
      this.hideAlert();
    }, 5000);
  }

  hideAlert() {
    this.showCustomAlert = false;
    setTimeout(() => {
      this.alertContent = {
        title: '',
        text: '',
        container: ''
      };
    }, 300);
  }
}


